export default "__VITE_ASSET__Jd7g00k4__"